<template>
    <v-layout fill-height>
        <v-flex xs12>
            <component :is="getViewComponent"
                       :layers="selectedLayers"
                       :mapConfig="mapConfig"
                       :activeMapTool="activeMapTool"
                       :filterConfig="filterConfig"
                       @boundsUpdate="updateBounds"
                       @zoomUpdate="updateZoom"
            ></component>
        </v-flex>
    </v-layout>
</template>

<script>
  import MapView from './Map'
  import ListView from './List'
  import _ from 'lodash'

  export default {
    props: {
      mode: {
        type: String,
        default: 'map'
      }
    },
    components: { MapView, ListView },
    data () {
      return {}
    },
    methods: {
      updateBounds (bounds) {
        this.filterConfig = Object.assign({}, this.filterConfig, { bounds })
        this.mapConfig = Object.assign({}, this.mapConfig, { bounds })
      },
      updateZoom (zoom) {
        this.mapConfig = Object.assign({}, this.mapConfig, { zoom })
        this.filterConfig = Object.assign({}, this.filterConfig, { zoom })
      }
    },
    computed: {
      getViewComponent () {
        return this.mode === 'map' ? MapView : ListView
      },
      selectedLayers () {
        let layers = []
        _.forEach(this.$store.getters['layer/getAllActiveSelected'], (selectedLayer) => layers.push(this.$store.getters['layer/get'](selectedLayer.id)))
        return layers
      },
      mapConfig: {
        get () {
          return this.$store.getters['geoview/getMapConfig']
        },
        set (data) {
          this.$store.dispatch('geoview/setMapConfig', data)
        }
      },
      filterConfig: {
        get () {
          return this.$store.getters['geoview/getFilterConfig']
        },
        set (data) {
          this.$store.dispatch('geoview/setFilterConfig', data)
        }
      },
      activeMapTool () {
        return this.$store.getters['geoview/getActiveTool']
      }
    }
  }
</script>

<style scoped>

</style>
